var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._b({class:[
    'hamburger',
    'hamburger--squeeze',
    { 'is-active': _vm.active, 'is-white': _vm.white } ],attrs:{"aria-label":"hamburger","type":"button"},on:{"click":function($event){return _vm.toggleMobileMenu({ value: !_vm.active })}}},'button',_vm.$attrs,false),[_vm._m(0)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"hamburger__box"},[_c('span',{staticClass:"hamburger__inner"})])}]

export { render, staticRenderFns }